import React from 'react';
import {useSelector} from 'react-redux';
import {format} from 'react-string-format';

import BackButton from '@/components/BackButton/BackButton';
import AppButton from '@/components/Button/AppButton';
import {ComputerBlueIcon} from '@/components/Icons';
import queryParameters from '@/consts/route/queryParameters';
import routePaths from '@/consts/route/routePaths';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import appContent from '@/services/content/appContent';
import deviceTypesService from '@/services/device/deviceTypesService';
import appRouterService from '@/services/route/appRouterService';
import {selectDeviceType} from '@/state/selectors/device';
import urlUtils from '@/utils/urlUtils';

const UsbRequiredPage = () => {
    const content = appContent.getUsbRequiredPopupContent();
    const {title, description, primaryButton, secondaryButton} = content || {};
    const primaryButtonLinkConfig = primaryButton?.externalLink;
    const {redirectToExternalLink} = useConfigExternalLink(primaryButtonLinkConfig);
    const [deviceTypeFromQuery] = urlUtils.getDataFromUrl(queryParameters.DEVICE_TYPE);
    const deviceTypeFromState = useSelector(selectDeviceType);
    const deviceType = deviceTypeFromQuery || deviceTypeFromState;
    const deviceName = deviceTypesService.getDeviceModelNameByType(deviceType);

    const redirectToSelectYourDevice = () => {
        const onBackRoute = routePaths.DEVICES_PAGE;

        appRouterService.forwardToSelectYourDevicePage({onBackRoute});
    };

    return (
        <section className='flex h-screen flex-1 flex-col gap-4 pt-safe-offset-4'>
            <BackButton className='ml-2' />
            <div className='flex flex-1 flex-col items-center gap-4 px-4 pb-8'>
                <ComputerBlueIcon className='h-16 w-16' />
                <h1 className='mb-0 px-6 leading-[40px]'>{title && format(title, deviceName || '')}</h1>
                <p>
                    {description &&
                        format(
                            description,
                            redirectToExternalLink ? (
                                <AppButton tertiary className='inline' onClick={redirectToExternalLink}>
                                    {primaryButton?.text}
                                </AppButton>
                            ) : undefined
                        )}
                </p>
            </div>
            <div className='w-full px-4 pt-4 pb-safe-offset-8'>
                <AppButton tertiary onClick={redirectToSelectYourDevice}>
                    {secondaryButton?.text}
                </AppButton>
            </div>
        </section>
    );
};

export default UsbRequiredPage;
